import React from "react";

const RenderAppraiser = ({ appraiser, colourise = false }) => {
    let display = "Not specified";
    let warning = false;

    if (!!appraiser?.length && appraiser[0]?.name) {
        display = appraiser[0].name;
    } else {
        if (colourise) {
            warning = true;
        }
    }

    return <span className={warning ? "error" : ""}>{display}</span>;
};

export default RenderAppraiser;
